import { render, staticRenderFns } from "./remarksList.vue?vue&type=template&id=2213ea78&scoped=true&"
import script from "./remarksList.vue?vue&type=script&lang=js&"
export * from "./remarksList.vue?vue&type=script&lang=js&"
import style0 from "./remarksList.vue?vue&type=style&index=0&id=2213ea78&lang=scss&scoped=true&"
import style1 from "./remarksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213ea78",
  null
  
)

export default component.exports